'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _electronSelector = require('./electronSelector');

var _electronSelector2 = _interopRequireDefault(_electronSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ElectronVisible = function ElectronVisible(_ref) {
    var children = _ref.children,
        isElectron = _ref.isElectron;
    return isElectron ? children : null;
};

ElectronVisible.propTypes = {
    isElectron: _react2.default.PropTypes.bool,
    children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node])
};

exports.default = (0, _reactRedux.connect)(_electronSelector2.default)(ElectronVisible);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/electron/ElectronVisible.js
// module id = 1755
// module chunks = 0